import { Cast } from "lucide-react";
import Sidebar, { SidebarItem } from "./components/Sidebar";
import { useEffect, useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useLocation,
  Navigate,
} from "react-router-dom";
import Login from "./scenes/login";
import Classes from "./scenes/classes";
import "@fontsource/nunito-sans";
import { useUser } from "./UserContext";
import { Toaster } from "react-hot-toast";
import Admin from "./scenes/admin";
import { subjectsShort } from "./constants";

function App() {
  const { login, user } = useUser();
  const [expanded, setExpanded] = useState(true);
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  useEffect(() => {
    const userLoggedIn = sessionStorage.getItem("user");
    const parsedData = JSON.parse(userLoggedIn);
    if (userLoggedIn !== null) {
      setIsLoggedIn(true);
      login(
        parsedData.studentNumber,
        parsedData.name,
        parsedData.section,
        parsedData.admin
      );
    } else {
      setIsLoggedIn(false);
    }

    const updateStatusBarColor = () => {
      const statusBarColor = "#198754";
      const metaTag = document.querySelector('meta[name="theme-color"]');
      if (metaTag) {
        metaTag.setAttribute("content", statusBarColor);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.setAttribute("name", "theme-color");
        newMetaTag.setAttribute("content", statusBarColor);
        document.head.appendChild(newMetaTag);
      }
    };

    updateStatusBarColor();
    // eslint-disable-next-line
  }, []);

  const hideSidebar = location.pathname === "/login";

  return (
    <div className="app">
      <Toaster position="top-right" toastOptions={{ duration: 5000 }} />
      {!hideSidebar && (
        <Sidebar expanded={expanded} setExpanded={setExpanded}>
          <hr className="my-3" />
          <SidebarItem
            alert
            icon={<Cast size={20} />}
            text="Class List"
            dropdownItems={subjectsShort}
          />
          {user?.admin && (
            <SidebarItem
              alert
              icon={<Cast size={20} />}
              text="Admininistrator"
              path="/admin"
            />
          )}
        </Sidebar>
      )}
      <main className="content">
        <Routes>
          <Route
            path="/"
            element={
              isLoggedIn ? (
                <Navigate to="/class/0" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/login"
            element={
              <Login expanded={expanded} setIsLoggedIn={setIsLoggedIn} />
            }
          />

          {isLoggedIn ? (
            <>
              <Route
                path="/class/:id"
                element={<Classes expanded={expanded} />}
              />

              {user?.admin && (
                <Route path="/admin" element={<Admin expanded={expanded} />} />
              )}

              <Route path="*" element={<Navigate to="/class/0" replace />} />
            </>
          ) : (
            <Route path="/*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </main>
    </div>
  );
}

function AppWithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWithRouter;
